import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";
import { MailingSettings } from "../app/Offers/model";

const updateBookingMailingSettings = async (bookingId: string, mailingSettings: MailingSettings) => {
  return fetch(`/api/bookings/${bookingId}/mailing-settings`, "PATCH", { mailingSettings });
};

export const useUpdateBookingMailingSettings = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { mailingSettings: MailingSettings; toastId: any }) =>
      updateBookingMailingSettings(bookingId, data.mailingSettings),
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Booking mailing settings updated successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to update booking mailing settings!",
        variant: "destructive",
      });
    },
  });
};
